import { Organisation } from '@ih/app/shared/apis/interfaces';

export class SetOrganisationAction {
  public static readonly type = '[Organisation] SetOrganisationAction';
  constructor(public readonly organisation: Organisation | null) {}
}
